import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Job Titles", -1)
const _hoisted_3 = { class: "row q-gutter-md q-mb-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        outlined: "",
        dense: "",
        name: "search",
        modelValue: _ctx.filter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        color: "primary",
        label: "Search by job title",
        clearable: "",
        class: "col-grow"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_q_table, {
      columns: _ctx.jobTitleColumns,
      rows: _ctx.filteredJobTitles,
      "row-key": "id",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
      flat: ""
    }, null, 8, ["columns", "rows", "pagination"])
  ]))
}